import { useQuoteApiServiceGetApiQuoteApiGetQuoteId } from "../../../../openapi/queries";
import { showErrorToast } from "../../../configurator/renderer/tools/helper";

import { JSX, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

//import { useLanguage } from "@4pace-cpq/core";
import { Box, CircularProgress, Container } from "@mui/material";
import { useNavigate, useSearch } from "@tanstack/react-router";

export const CustomOpportunityRouteComponent = ({
  checkLogin,
}: {
  checkLogin: () => void;
}): JSX.Element => {
  const { t } = useTranslation();
  const { data: quoteId } = useQuoteApiServiceGetApiQuoteApiGetQuoteId();
  const [isLoadingWebWebsite, setIsLoadingWebWebsite] = useState<boolean>(true);
  const navigate = useNavigate();
  const {
    language,
    origin,
    purchaseCountry,
    catalog,
    customer,
    customerName,
    productCategory,
    intermediateToken,
    sessionFromEasy,
  } = useSearch({ strict: false });

  //const { setLanguageById, languages } = useLanguage();

  /*   useEffect(() => {
    if (language) {
      const languageData = languages.find(
        (lang) => lang.languageCode?.split("-")[0] === language,
      );
      if (languageData) {
        setLanguageById(languageData.id);
      }
    }
  }, [language, languages, setLanguageById]); */

  const handlePostSessionFromWegWebsite =
    useCallback(async (): Promise<void> => {
      setIsLoadingWebWebsite(true);
      await fetch("/api/Easy/SessionFromWegWebsite", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          language,
          origin,
          purchaseCountry,
          catalog,
          customer,
          customerName,
          productCategory,
          intermediateToken,
        }),
      }).then(async (response) => {
        console.log({ response });
        setIsLoadingWebWebsite(false);
        checkLogin();
        navigate({
          to: "/cart/view",
          search: () => ({
            productCategory,
            language,
          }),
        });
        if (!response.ok) {
          const data = await response.json();
          showErrorToast(t(`WEG:${data.key}`, { params: data.params }));
        }
      });
    }, [
      language,
      origin,
      purchaseCountry,
      catalog,
      customer,
      customerName,
      productCategory,
      intermediateToken,
      checkLogin,
      navigate,
      t,
    ]);

  const handleUseSessionFromEasy = useCallback(async (): Promise<void> => {
    setIsLoadingWebWebsite(true);
    await fetch(`/api/QuoteApi/ConvertSessionFromEasy/${sessionFromEasy}`, {
      method: "GET",
    }).then(() => {
      setIsLoadingWebWebsite(false);
      checkLogin();
      navigate({
        to: "/cart/view",
        search: () => ({
          language,
        }),
      });
    });
  }, [checkLogin, navigate, sessionFromEasy, language]);

  useEffect(() => {
    if (sessionFromEasy) {
      handleUseSessionFromEasy();
    } else if (origin && productCategory) {
      handlePostSessionFromWegWebsite();
    } else if (quoteId && !origin) {
      navigate({
        to: "/cart/view",
        search: () => ({
          language,
        }),
      });
    }
  }, [
    language,
    handlePostSessionFromWegWebsite,
    origin,
    productCategory,
    handleUseSessionFromEasy,
    sessionFromEasy,
    navigate,
    quoteId,
  ]);

  return (
    <Container>
      <Box my={4}>
        {isLoadingWebWebsite || !quoteId ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={4}
          >
            <CircularProgress />
          </Box>
        ) : (
          <></>
        )}
        <Box display="flex" flexDirection="column" gap={1}></Box>
      </Box>
    </Container>
  );
};
